module.exports = __webpack_public_path__ + "media/images/one-store-1-a406f1704b17a0562142ca8edecb5fe8.jpg";